/**
 * Checks if a repository description contains HTML tags.
 * This should only be used for repository descriptions, which have '<' and '>' entities escaped when not
 * used as part of HTML tags.
 *
 * TODO: Remove this function with the removal of `repos_list_minimal_description_pipeline` feature flag.
 */
export function containsHtml(text: string) {
  return text.includes('<')
}
